<template>
  <div class="cs_title">
    <h2 class="animated">客服中心</h2>
    <div class="cus_login_wrapper login fl">
      <div class="login_box">
        <span class="logo">隱私權政策</span>
        <div style="text-align: left; padding: 10px 20px; font-family: 微軟正黑體; font-size: 12pt">
          <!-- <p style="background-color: #ffffff; margin: 15pt 0pt 7.5pt; text-align: center; font-weight: bold">隱私權政策</p> -->
          <p class="ind">歡迎您 蒞臨荷米斯遊戲網站(以下簡稱本網站)。</p>
          <p>荷米斯遊戲有限公司（公司統一編號：82909803）為了尊重您個人的隱私權,讓您能夠安心的使用本網站的各項服務與資訊,因此制訂了隱私權保護政策。
            對於本網站如何蒐集、應用及保護您所提供的個人資訊,特此向您說明本網站的隱私權保護政策,以保障您的權益,請您詳閱下列內容:</p>
          <br />
          <h4>隱私權保護政策的適用範圍</h4>
          <p>隱私權保護政策內容,包括本網站如何處理您在使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站,也不適用於非本網站所委託或參與管理的第三人。</p>
          <br />
          <h4>個人資料的蒐集、處理及利用方式</h4>
          <p>1.單純在本網站瀏覽或檔案下載行為,本網站並不會蒐集任何有關您個人的識別資料。</p>
          <p>
            2.當您註冊成為本網站的會員時,本網站會請您提供包括姓名、身份證字號或護照號碼(外國人)、住址、電話、電子信箱等個人資訊,我們取得這些資訊是為了提供您購買、記錄道具、累積幣值、訊息傳遞等服務(法務部個人資料特定目的項目代號:090消費者、客戶管理與服務;135資(通)訊服務;136資(通)訊與資料庫管理;148網路購物及其他電子商務服務)。
          </p>
          <p>3.利用本網站所提供的客戶服務信箱或各項線上申辦服務,需申請人提供個人資料時,會依案件辦理需求請您提供姓名、聯絡電話、電子郵箱、通訊住址及戶籍地址等個人最新、真實之資料。</p>
          <p>
            4.藉由對本隱私權政策之同意,您同意我們存取您在Facebook內之資訊之方式,並授權我們透過本服務及相關之應用程式取得、存取,並以尊重用戶隱私權為原則,允許您刪除個人帳號相關的關聯授權,以Facebook授權帳號為例之操作如下:
          </p>
          <p>  1) 使用Facebook登入功能登入應用。</p>
          <p>  2) 前往Facebook個人主頁的"應用和網站"設置選項。</p>
          <p>  3) 移除您需要取消授權的應用。</p>
          <p>  4) 點選"查看已移除的應用和網站"選項,然後點選"查看"您已取消授權的應用。</p>
          <p>  5) 點選發送請求,我方將受理此請求,並執行數據刪除的操作。</p>

          <p>6.會員同意本公司得不定期發送電子報或營銷訊息至會員所登錄的電子信箱帳號或手機簡訊、資訊與資料庫管理、統計調查與分析;向您提供行銷優惠及會員服務;
            回應您的意見及問題,並提供或改善我們的服務及支援;向您更新我們最新的服務,並於前述目的範圍內利用您所提供之個人資料。</p>
          <p>7.我們重視您向我們提供您的個人資訊的信任,因此我們正在努力使用商業上可接受的方式來最大程度保護它。但您同意沒有一種網際網路傳輸方式或電子存儲方式是100%安全可靠的,我們無法保證其絕對安全。</p>
          <br />

          <h4>資料之保護</h4>
          <p>1.請妥善保管您的帳號及密碼或任何個人資料,不要將任何個人資料,提供給任何人,若您是與人共享電腦或用公共電腦,請務必記得登出,並切記關閉瀏覽器視窗,以防止他人讀取您的個人資料或信件。</p>
          <p>2.如有必要委託本網站相關單位提供服務時,只有經過授權的人員才能接觸您的個人資料,相關處理人員皆簽有保密合約。</p>
          <p>3.本網站亦會恪守台灣個人資料保護法之規定,提供適當安全維護措施以保護您的個人資料之安全性。對於任何違法盜用或揭露個人資料的不法及不當行為,本網站定將採取必要的法律行動,以確保您的權益。</p>
          <br />

          <h4>無行為能力或限制行為能力人之保護</h4>
          <p>
            對於未能依本網站服務協定規範而使用服務的無行為能力或限制行為能力人,本網站不會有意收集其個人身份資訊,如果您是上述無行為能力或限制行為能力人的法定監護人,並且知道其向我們提供了個人資訊,請與我們聯繫,以便我們能夠採取必要的行動。
          </p>
          <br />

          <h4>資料刪除請求之處理辦法</h4>
          <p>您可依個人資料保護法,就您的個人資料向本公司請求停止蒐集或請求刪除。 上述的請求可透過信箱service@hermesgames.com.tw
            或遊戲內客服中心與我們聯絡。當您要求刪除您的個人資料時,將於確認會員身份後,提供會員契約終止申請書,填寫完成後請再將此份申請書利用郵寄方式寄回本公司,並須依契約之終止作業流程檢附證件處理。但因本公司執行職務或業務所必需者,本公司得拒絕之。
            完成契約之終止作業服務流程後,本公司將終止服務契約,您將無法再以該會員身分登入本服務。</p>
          <br />

          <h4>網站對外的相關連結</h4>
          <p>
            本網站的網頁提供其他網站的網路連結,您也可經由本網站所提供的連結,點選進入其他網站,但該連結網站不適用本網站的隱私權保護政策,點選進入其他網站前,建議您務必瀏覽該連結網站中的隱私權保護政策。本網站並不保護您關於網站中的隱私權及相關問題。
          </p>
          <br />

          <h4>與第三人共用個人資料之政策</h4>
          <p>本網站不會提供、交換、出租或出售任何您的個人資料給未經您授權的第三人、團體、私人企業或公務機關。但有下列情形者除外:</p>
          <p>1.為了提供您其它服務或優惠權益,需要與提供該服務或優惠之其他人士或公司共用您的資料時,本網站會在活動時提供充分說明,你可以自由選擇是否接受這項特定服務或優惠。</p>
          <p>2.為提供必要託管、玩家支援、廣告、分析和欺詐預防等服務,本網站工作的合作夥伴將僅按照本網站的指示處理您的資料。</p>
          <p>3.若您透過本公司有購物、兌換贈品,因而產生的金流、物流必要,本公司有可能會提供您前述範圍內必要的個人識別資料給相關機關或合作、協力廠商作為交易驗證或商品送達之用。</p>
          <p>4.經司法機關依法要求提供，或我們發覺你在網站上有違法行為，本網站將依法配合司法單位協助調查。</p>
          <p>5.保護或防衛相關使用網路服務之用戶權利及所有權。</p>
          <p>6.為保護本公司各相關單位之權益。</p>
          <p>7.配合相關職權機關依職務需要之調查或使用。</p>
          <p>8.基於善意、相信之前提，揭露隱私資訊為法律之需要，或為維護與改進網站服務之管理。</p>
          <br />

          <h4>Cookie之使用</h4>
          <p>
            為了提供更好的個人化服務，本網站可能會使用Cookies來存儲並在某些時候追蹤有關使用者的資料。本網站的Cookies使用是基於：估算瀏覽人數、測量瀏覽模式。這些資料僅止於商業及市場分析或學術用途。Cookies亦可供作第三人，例如廣告服務公司在我們的網頁設立廣告，這些廣告服務公司可以利用Cookies蒐集到非相關於您個人可資辨識之的資料，廣告業者可以利用這種資訊，作為分析行銷指標並評估其影響力，所有資料僅供資料分析用。
          </p>
          <br />

          <h4>其他依法告知事項</h4>
          <p>對於本網站蒐集、處理及利用個人資料，您可以依台灣個人資料保護法第3條規定行使下列權利：</p>
          <p>1. 查詢或請求閱覽。</p>
          <p>2. 請求製給複製本。</p>
          <p>3. 請求補充或更正。</p>
          <p>4. 請求停止蒐集、處理或利用。</p>
          <p>5. 請求刪除。</p>
          <br />

          <h4>聯繫我們</h4>
          <p>如果您對我們的隱私政策有任何疑問或建議，請隨時聯繫我們。</p>
          <p>荷米斯遊戲有限公司（統一編號：82909803）</p>
          <p>請發送郵件至service@hermesgames.com.tw 郵箱。</p>
          <br />

          <h4>隱私權保護政策之修正</h4>
          <p>為提供給您更好的服務，本站將配合各項相關法令規定定期增刪修改本隱私權政策，經過增刪或修改後的內容應以本網站公告時間為生效日。</p>

          <p>最新公告日期：西元2026年08月。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerContactus",
  data: function () {
    return {};
  },
};
</script>

<style lang="stylus" scoped>
.v-enter, .v-enter-to {
  opacity: 0;
}

.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

/* 滚动槽 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(252, 197, 5, 0.08);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  max-height: 10px;
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.8);
  -webkit-box-shadow: inset 0 0 10px rgba(252, 197, 5, 1);
}

.cs_title {
  width: 902px;

  h2 {
    position: relative;
    display: block;
    width: 100%;
    text-indent: 30px;
    font-size: 47.02px;
    color: #4b4b4b;
    font-weight: 500;
    text-indent: 55px;
    margin-bottom: 40px;

    &::before {
      content: '';
      position: absolute;
      width: 36px;
      height: 41px;
      top: 50%;
      left: 342px;
      margin-top: -18px;
      background: url('../../assets/imgs/hms-icon.png') no-repeat center;
      background-size: 298px 276px;
      background-position: -203px -91px;
    }
  }
}

.cus_login_wrapper {
  position: absolute;
  width: 900px;
  height: 667px;
  border: 3px solid #898888;
  box-sizing: border-box;
  overflow-y: auto;

  .login_box {
    margin: 0 auto;

    .c_content {
      overflow-y: auto;
      width: 800px;
      margin: 0 auto;
      height: 511px;
      line-height: 24px;
      margin-top: 10px;
      padding: 20px;
      border: 2px solid #898888;
      text-align: left;
      font-size: 14px;

      p {
        width: 100%;
        text-align: left;
        font: size 16px;
        font-weight: 700;
        margin-top: 20px;
        margin-bottom: 10px;

        &.title {
          font-size: 16px;
          text-align: center;
        }

        &.ind {
          text-indent: 2em;
          font-weight: inherit;
        }
      }
    }

    .con {
      li {
        position: relative;
        text-align: left;
        font-size: 20px;

        &.mart {
          margin-top: 38px;
          margin-bottom: 18px;
          text-indent: 2rem;

          &::before {
            content: '';
            position: absolute;
            width: 25px;
            height: 26px;
            top: 0;
            left: 0;
            background: url('../../assets/imgs/hms-icon.png') no-repeat center;
            background-size: 298px 276px;
            background-position: -230px -155px;
          }
        }
      }
    }

    .form {
      dl {
        overflow: inherit;
      }

      .con {
        width: 290px;
      }
    }

    .login_close {
      position: absolute;
      width: 89px;
      height: 82px;
      right: 0;
      top: 0;
      border-top-right-radius: 30%;
      background: url('../../assets/imgs/close.png') no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;

      i {
        display: inline-block;
        width: 31.67px;
        height: 5.65px;
        position: absolute;
        right: 9px;
        top: 18px;
        background: #ffffff;
        border-radius: 2.5px;
      }
    }

    .logo {
      display: inline-block;
      width: 460px;
      margin: 17px auto 10px;
      font-size: 26px;
      color: #4b4b4b;
      padding-bottom: 10px;
      border-bottom: 3px solid #fcc505;

      i {
        display: inline-block;
        width: 70px;
        height: 51px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -35px;
        margin-top: -25.5px;
        background: #4b4b4b;
        border-radius: 2.5px;
      }
    }

    .icon {
      span {
        display: inline-block;
        color: #545454;
        font-size: 14px;
        vertical-align: top;
        margin-right: 25px;
        margin-top: 8px;
      }

      div {
        display: inline-block;
        width: 39px;
        height: 46px;
        margin-top: 8px;
        background: url('../../assets/imgs/game-icon.png') no-repeat center;
        background-size: 500px 500px;
        cursor: pointer;

        &.gg {
          background-position: 0 -166px;
        }

        &.tw {
          background-position: -61px -166px;
        }

        &.fb {
          background-position: -123px -166px;
        }
      }
    }

    .login_reg {
      a {
        color: #2c2c2c;
        font-size: 14px;
      }
    }
  }
}
</style>
